import { PriceBook } from '@snap-types/models/price-book';
import { Decimal } from '@snap-types/types/decimal';
import { isNil, sortBy, zip } from 'lodash-es';

import { convertDefaultPriceToQuantityBreak } from './default-unit-price';

export type FixedQuantityBreak = {
  quantity: Decimal;
  unitPrice: Decimal;
};

export function convertPriceBookToQuantityBreaks(
  entry: PriceBook,
): FixedQuantityBreak[] {
  const quantities = [
    entry.qty_break_1,
    entry.qty_break_2,
    entry.qty_break_3,
    entry.qty_break_4,
    entry.qty_break_5,
    entry.qty_break_6,
    entry.qty_break_7,
    entry.qty_break_8,
    entry.qty_break_9,
    entry.qty_break_10,
  ];

  const unitPrices = [
    entry.unit_price_1,
    entry.unit_price_2,
    entry.unit_price_3,
    entry.unit_price_4,
    entry.unit_price_5,
    entry.unit_price_6,
    entry.unit_price_7,
    entry.unit_price_8,
    entry.unit_price_9,
    entry.unit_price_10,
  ];

  // Build quantity breaks, removing any null values
  const quantityBreaks = zip(quantities, unitPrices)
    .map(([quantity, unitPrice]) => {
      return { quantity, unitPrice };
    })
    .filter<FixedQuantityBreak>((qb): qb is FixedQuantityBreak => {
      return !isNil(qb.quantity) && !isNil(qb.unitPrice);
    });

  // Add the default quantity break if:
  //  - price book has a default
  //  - quantity breaks don't already have quantity 1
  const hasQuantityOne = quantityBreaks.some(({ quantity }) =>
    quantity.eq(new Decimal('1')),
  );

  const defaultQuantityBreak = convertDefaultPriceToQuantityBreak(entry);

  if (!hasQuantityOne && defaultQuantityBreak) {
    quantityBreaks.unshift(defaultQuantityBreak);
  }

  // Sort breaks by quantity
  return sortBy(quantityBreaks, (qb) => qb.quantity.toNumber());
}
